import { InjectionToken } from '@angular/core';

export const CONFIG_PATH = new InjectionToken<string>('configPath', { factory: () => '/config.json' });
